export const maxLogoSize = 5 * 1024 * 1024; // 10 MB
export const logoFormat = ["image/png", "image/jpeg", "image/webp", "image/svg+xml"];
export const DEFAULT_FRAME_COLOR = "#000099";
export const DEFAULT_SITE_NAME = "rpr-IoT";
export const RPR_LOGO_WHITE = '/rpr-logo-white.png';
export const RPR_LOGO_BLUE = '/rpr-logo-blue.png'
export const CLIENT_CODE_STORAGE_KEY = 'clientCode'
export const LOGIN_CLIENT_CODE_PARAM_KEY = 'client_code'

const rgbRegex = /^rgb\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*\)$/i;
const hexRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
const hslRegex = /^hsl\(\s*\d{1,3}\s*,\s*\d{1,3}%\s*,\s*\d{1,3}%\s*\)$/i;

export const isValidFrameColorFormat = (color: string | undefined): boolean => {
  if (!color) return false;
  return rgbRegex.test(color) || hexRegex.test(color) || hslRegex.test(color);
};
export const rgbToHex = (rgb: string): string => {
  if (!rgbRegex.test(rgb)) return "#000000";

  const result = rgb.match(/\d+/g);
  if (!result || result.length < 3) return "#000000";

  const [r, g, b] = result.slice(0, 3).map(Number);

  if ([r, g, b].some((n) => n < 0 || n > 255)) return "#000000";

  return "#" + [r, g, b].map((x) => x.toString(16).padStart(2, "0")).join("");
};
const hslToRgbArray = (h: number, s: number, l: number): [number, number, number] => {
  h = h % 360;
  const c = (1 - Math.abs(2 * l - 1)) * s;
  const hp = h / 60;
  const x = c * (1 - Math.abs((hp % 2) - 1));
  let r1 = 0,
    g1 = 0,
    b1 = 0;

  if (0 <= hp && hp < 1) [r1, g1, b1] = [c, x, 0];
  else if (1 <= hp && hp < 2) [r1, g1, b1] = [x, c, 0];
  else if (2 <= hp && hp < 3) [r1, g1, b1] = [0, c, x];
  else if (3 <= hp && hp < 4) [r1, g1, b1] = [0, x, c];
  else if (4 <= hp && hp < 5) [r1, g1, b1] = [x, 0, c];
  else if (5 <= hp && hp < 6) [r1, g1, b1] = [c, 0, x];

  const m = l - c / 2;
  const r = Math.round((r1 + m) * 255);
  const g = Math.round((g1 + m) * 255);
  const b = Math.round((b1 + m) * 255);

  return [r, g, b];
};
export const hslToHex = (hsl: string): string => {
  if (!hslRegex.test(hsl)) return "#000000";

  const result = hsl.match(/(\d+(?:\.\d+)?)/g);
  if (!result || result.length < 3) return "#000000";

  const h = Number(result[0]);
  const s = Number(result[1]);
  const l = Number(result[2]);

  if (h < 0 || h > 360 || s < 0 || s > 100 || l < 0 || l > 100) return "#000000";

  const [r, g, b] = hslToRgbArray(h, s / 100, l / 100);

  return "#" + [r, g, b].map((x) => x.toString(16).padStart(2, "0")).join("");
};
export const colorToHex = (color: string): string => {
  if (!color) return "#000000";

  const c = color.trim().toLowerCase();

  if (hexRegex.test(c)) {
    // Normalize shorthand hex (#abc to #aabbcc)
    if (c.length === 4) {
      return "#" + c[1].repeat(2) + c[2].repeat(2) + c[3].repeat(2);
    }
    return c;
  } else if (rgbRegex.test(c)) {
    return rgbToHex(c);
  } else if (hslRegex.test(c)) {
    return hslToHex(c);
  }
  return "#000000";
};
export const DEFAULT_LOGIN_STYLE = {
  frame_color: DEFAULT_FRAME_COLOR, //  Previously used on login "#2563eb",
  site_name: DEFAULT_SITE_NAME,
  logo_url: RPR_LOGO_WHITE,
} as const;